import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const rateTypesAdapter = getAdapter({ idFieldName: 'value' });

const rateTypesSlice = createSlice({
  name: 'rateTypes',
  initialState: rateTypesAdapter.getInitialState(),
  reducers: {
    setRateTypes: (state, { payload: { rateTypes } }) => {
      rateTypesAdapter.setAll(state, rateTypes);
    },
  },
});

const selectors = rateTypesAdapter.getSelectors(({ rateTypes }) => rateTypes);

export const getAllRateTypes = (state) => selectors.selectAll(state);

export const {
  setRateTypes,
} = rateTypesSlice.actions;

export default rateTypesSlice.reducer;
